import { createStore } from 'redux';
import { graphql } from 'gatsby'


let initalState = {
    recentBlogPosts: false
}

function reducer(state = initalState, action) {
    switch (action.type) {
        case 'set_recentBlogPosts':
            return state.recentBlogPosts = action.data
        default:
            return state
    }
}

// preloadedState will be passed in by the plugin
export default preloadedState => {
  return createStore(reducer, preloadedState);
};
